import React, { useState } from 'react';
import {
  TextField,
  Button,
  FormGroup,
  Typography,
  Box,
  InputLabel,
  Stack,
} from '@mui/material';

import Config from '../../../../Config';

// OUR COMPONENTS
import DeviceSearchList from './DeviceSearchList';

// NETWORK
import useDeviceRequest from '../../../../requests/DeviceRequest';
import Paginator from '../../../common/Paginator';

export default function DeviceSearch({
  viewAllDevices,
  showSingleDevice,
  showSingleCustomer,
  showSingleUserReport,
  showSinglePhoneNumber,
  errorHandler,
}) {
  // Replace state with useState
  const [devices, setDevices] = useState([]);
  const [edits, setEdits] = useState({});
  const [hasSearched, setHasSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLength, setPageLength] = useState(Config.defaultPL);
  const { searchDevices } = useDeviceRequest();

  // Handle form change
  const handleFormChange = (event) => {
    const { name, value } = event.target;

    console.log('Edits is:', { ...edits, [name]: value });

    setEdits({
      ...edits,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setHasSearched(true);
    setLoading(true);
    setDevices([]);

    let data = edits;

    // Filter out empty string values
    let filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== '')
    );

    let devices = await searchDevices(filteredData, errorHandler);
    setDevices(devices);
    setPageNumber(1);
    setLoading(false);
  };

  // Generate lander
  const generateLander = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 2,
        }}
      >
        <Typography variant="h3">Device Search</Typography>
        {generateViewAllDevicesButton()}
      </Box>
    );
  };

  // Change page length
  const changePageLength = (event) => {
    const value = event.target.value;
    setPageLength(value);
    setPageNumber(1);
  };

  // Handle page change
  const changeEvent = (value) => {
    setPageNumber(value);
  };

  // Generate form group
  const generateFormGroup = (name, label) => {
    return (
      <FormGroup>
        <Stack
          sx={{
            flexDirection: { md: 'row' },
            alignItems: { md: 'center' },
            gap: { md: 2 },
          }}
        >
          <InputLabel sx={{ minWidth: 200 }}>{label}</InputLabel>
          <TextField
            name={name}
            type="text"
            value={edits[name] || ''}
            onChange={handleFormChange}
            fullWidth
            size="small"
          />
        </Stack>
      </FormGroup>
    );
  };

  // Generate view all devices button
  const generateViewAllDevicesButton = () => {
    return (
      <Button
        variant="contained"
        color="secondary"
        type="submit"
        onClick={viewAllDevices}
      >
        View ALL Devices
      </Button>
    );
  };

  // Generate RedOx search form
  const generateRedOxSearchForm = () => {
    return (
      <Box>
        <form onSubmit={handleSubmit} onChange={handleFormChange}>
          <Stack gap={2} maxWidth={800}>
            {generateFormGroup('customer_id', 'Customer Id:')}
            {generateFormGroup('customer_user_id', 'User Id:')}
            {generateFormGroup('device_id', 'Device Id:')}
            {generateFormGroup('device_name', 'Device Name:')}
            {generateFormGroup('reply_tn', 'ReplyTn:')}
            <Box>
              <Button variant="contained" color="secondary" type="submit">
                Search
              </Button>
            </Box>
          </Stack>
        </form>
      </Box>
    );
  };

  // Generate results table
  const generateResultsTable = () => {
    if (!hasSearched) return;

    return (
      <Box>
        <DeviceSearchList
          devices={devices.slice(
            (pageNumber - 1) * pageLength,
            (pageNumber - 1) * pageLength + pageLength
          )}
          showSingleDevice={showSingleDevice}
          showSingleCustomer={showSingleCustomer}
          showSingleUserReport={showSingleUserReport}
          showSinglePhoneNumber={showSinglePhoneNumber}
          loading={loading}
        />
        <Paginator
          itemCount={devices?.length}
          pageNumber={pageNumber}
          changeEvent={changeEvent}
          pageLength={pageLength}
          editFunction={changePageLength}
        />
      </Box>
    );
  };

  // Render
  return (
    <Box>
      <Box sx={{ marginBottom: 4 }}>
        {generateLander()}
        {generateRedOxSearchForm()}
      </Box>
      {generateResultsTable()}
    </Box>
  );
}
